export const CLIENT_ID="y1HQditNYCfMMLuGG92aVzDt7zlWrIP6";
export const URI="https://developer.api.autodesk.com";
export const REDIRECT_URL="https://redex.onecloud.red-eng.com/";